export default "__VITE_ASSET__6ed9861f__"